export default {"src":"/_next/static/media/down-caret.9f31fae6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};